import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BlogItem from "../components/BlogItem";
import Sidebar from "../components/sidebar/Sidebar";
import { fetchBlogs } from "../features/blogs/BlogsSlice";
import { filterBlogs, sortBlogs } from "../utils/commonUtility";

export default function Blog () {
    const dispatch = useDispatch();
    const { value: filterValue } = useSelector(state => state.filter);
    const { value: sortValue } = useSelector(state => state.sort);

    let { blogs, isLoading, isError, errorMessage } = useSelector(state => state.blogs);
    let blogList = blogs.map(blog => ({...blog }));

    sortBlogs(blogList, sortValue);
    blogList = filterBlogs(blogList, filterValue);

    useEffect(() => {
        dispatch(fetchBlogs());
    }, [dispatch]);
    
    let content = null;
    if (isLoading) {
        content = <div>Blogs loading...</div>;
    }
    else if (!isLoading && isError) {
        content = <div>{errorMessage}</div>;
    }
    else if (!isLoading && !isError && blogList?.length > 0) {
        content = blogList.map(blog => <BlogItem key={blog.id} blog={blog} />);
    }
    else {
        content = <div>No blogs found!!</div>;
    }

    return (
        <section className="wrapper">
            <Sidebar />
            <main className="post-container" id="lws-postContainer">
                {content}
            </main>
        </section>
    );
}